import React from 'react';
import FeaturedBlogCard from './FeaturedBlogCard';
import ContactPage from './ContactPage'
import { Container } from 'react-bootstrap';

function Bulkorder() {
  return (
    <Container>    <div class="section__header spacing--large md:text-center text-center p-5">
 <FeaturedBlogCard
 
 />
 <ContactPage/>
 
    </div>
    </Container>

  );
}

export default Bulkorder;
